import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import IxDialog from '~/components/ix/Dialog.vue';
import IxFormInputDatePicker from '~/components/ix/form-input/DatePicker.vue';
import IxFormInputDateRangePicker from '~/components/ix/form-input/DateRangePicker.vue';
import { useAddQuestionnaireMutation, useUpdateQuestionnaireMutation, useGetAccountQuery, useGetEsgQuestionnaireResultsForVenturesQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'RequestNewEsgQuestionnaire',
  props: {
    selected: {
      default: function _default() {
        return [];
      }
    },
    mode: {
      default: 'request'
    },
    questionnairesToEdit: {
      default: function _default() {
        return [];
      }
    }
  },
  emits: ["input", "cancel", "saved"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useGetAccountQuery = useGetAccountQuery(),
      result = _useGetAccountQuery.result;
    var portfolioId = computed(function () {
      var _result$value, _result$value$getAcco;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$getAcco = _result$value.getAccount) === null || _result$value$getAcco === void 0 ? void 0 : _result$value$getAcco.id;
    });
    var _useUpdateQuestionnai = useUpdateQuestionnaireMutation(),
      mutate = _useUpdateQuestionnai.mutate,
      loadingUpdate = _useUpdateQuestionnai.loading;
    var _useAddQuestionnaireM = useAddQuestionnaireMutation(),
      addQuestionnaire = _useAddQuestionnaireM.mutate,
      onDoneaddQuestionnaire = _useAddQuestionnaireM.onDone;
    var _useGetEsgQuestionnai = useGetEsgQuestionnaireResultsForVenturesQuery({
        ventureIds: []
      }),
      refetchEsgQuestionnaireResults = _useGetEsgQuestionnai.refetch;
    var referencePeriod = ref({
      standard: "",
      isCustom: false,
      dueDate: null,
      custom: []
    });
    var sendNotification = ref(true);
    var createNewQuestionnaireRequest = function createNewQuestionnaireRequest(ventureIds) {
      var assignedBy = portfolioId.value;
      var input = null;
      if (referencePeriod.value.isCustom && referencePeriod.value.custom.length === 2) {
        input = {
          startDate: referencePeriod.value.custom[0],
          endDate: referencePeriod.value.custom[1],
          userDefined: true
        };
      } else if (referencePeriod.value.standard) {
        var standard = referencePeriod.value.standard;
        input = {
          id: standard.id,
          label: standard.label,
          startDate: standard.startDate,
          endDate: standard.endDate,
          userDefined: standard.userDefined
        };
      }
      addQuestionnaire({
        ventureIds: ventureIds,
        referencePeriod: input,
        doSendNotification: sendNotification.value
      });
      onDoneaddQuestionnaire(function (_) {
        return refetchEsgQuestionnaireResults();
      });
    };
    var handleSubmitReferencePeriodRequest = function handleSubmitReferencePeriodRequest(selected) {
      var ventureIds = selected.map(function (item) {
        return item.ventureId;
      });
      createNewQuestionnaireRequest(ventureIds);
    };
    var handleResetReferencePeriodInput = function handleResetReferencePeriodInput(val) {
      if (val === false) {
        referencePeriod.value.dueDate = null;
        referencePeriod.value.standard = "";
        referencePeriod.value.isCustom = false;
        referencePeriod.value.custom = [];
      }
    };
    var sendDisabled = computed(function () {
      var _referencePeriod$valu;
      if (referencePeriod.value.isCustom) {
        return (referencePeriod === null || referencePeriod === void 0 ? void 0 : referencePeriod.value.custom.length) !== 2;
      }
      return !(referencePeriod !== null && referencePeriod !== void 0 && (_referencePeriod$valu = referencePeriod.value) !== null && _referencePeriod$valu !== void 0 && _referencePeriod$valu.standard);
    });
    var editDisabled = computed(function () {
      return sendDisabled.value;
    });
    function buildReferencePeriodInput() {
      if (referencePeriod.value.isCustom && referencePeriod.value.custom.length === 2) {
        return {
          startDate: referencePeriod.value.custom[0],
          endDate: referencePeriod.value.custom[1],
          userDefined: true
        };
      }
      if (referencePeriod.value.standard) {
        var standard = referencePeriod.value.standard;
        return {
          id: standard.id,
          label: standard.label,
          startDate: standard.startDate,
          endDate: standard.endDate,
          userDefined: standard.userDefined
        };
      }
      return null;
    }
    function handleEditReferencePeriods() {
      return _handleEditReferencePeriods.apply(this, arguments);
    }
    function _handleEditReferencePeriods() {
      _handleEditReferencePeriods = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props$questionnaires;
        var refPeriod;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              refPeriod = buildReferencePeriodInput();
              if (!(!refPeriod || !((_props$questionnaires = props.questionnairesToEdit) !== null && _props$questionnaires !== void 0 && _props$questionnaires.length))) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return Promise.all(props.questionnairesToEdit.map(function (q) {
                var input = {
                  id: q.id,
                  referencePeriod: refPeriod
                };
                return mutate({
                  input: input
                });
              }));
            case 5:
              refetchEsgQuestionnaireResults();
              emit('saved');
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleEditReferencePeriods.apply(this, arguments);
    }
    return {
      __sfc: true,
      emit: emit,
      props: props,
      result: result,
      portfolioId: portfolioId,
      mutate: mutate,
      loadingUpdate: loadingUpdate,
      addQuestionnaire: addQuestionnaire,
      onDoneaddQuestionnaire: onDoneaddQuestionnaire,
      refetchEsgQuestionnaireResults: refetchEsgQuestionnaireResults,
      referencePeriod: referencePeriod,
      sendNotification: sendNotification,
      createNewQuestionnaireRequest: createNewQuestionnaireRequest,
      handleSubmitReferencePeriodRequest: handleSubmitReferencePeriodRequest,
      handleResetReferencePeriodInput: handleResetReferencePeriodInput,
      sendDisabled: sendDisabled,
      editDisabled: editDisabled,
      buildReferencePeriodInput: buildReferencePeriodInput,
      handleEditReferencePeriods: handleEditReferencePeriods,
      IxDialog: IxDialog,
      IxFormInputDatePicker: IxFormInputDatePicker,
      IxFormInputDateRangePicker: IxFormInputDateRangePicker
    };
  }
});